import React from 'react';

/**
 * Actions standards de ligne : Modifier | Désactiver (membre) | Suppression définitive (optionnel)
 */
const TableRowActions = ({
  onEdit,
  /** Réinitialisation mot de passe (admin / droit users.edit) */
  onPasswordReset,
  /** @deprecated Utiliser `onDeactivate` pour la désactivation membre */
  onDelete,
  onDeactivate,
  onHardDelete,
  editLabel = 'Modifier',
  resetPasswordLabel = 'Réinitialiser le mot de passe',
  deleteLabel = 'Supprimer',
  deactivateLabel = 'Désactiver le membre',
  hardDeleteLabel = 'Supprimer définitivement',
  className = '',
}) => {
  const showMemberDeactivate = typeof onDeactivate === 'function';
  const showLegacyDelete = typeof onDelete === 'function' && !showMemberDeactivate;

  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      {typeof onEdit === 'function' && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(e);
          }}
          title={editLabel}
          aria-label={editLabel}
          className="inline-flex items-center justify-center h-8 w-8 rounded-md text-entrea-royal hover:text-entrea-navy hover:bg-entrea-panel transition"
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
          </svg>
        </button>
      )}
      {typeof onPasswordReset === 'function' && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onPasswordReset(e);
          }}
          title={resetPasswordLabel}
          aria-label={resetPasswordLabel}
          className="inline-flex items-center justify-center h-8 w-8 rounded-md text-sky-700 hover:text-sky-900 hover:bg-sky-50 transition"
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path
              fillRule="evenodd"
              d="M10 1a4.5 4.5 0 00-4.5 4.5V7H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2V9a2 2 0 00-2-2h-.5A4.5 4.5 0 0010 1zm3 6V5.5a3 3 0 10-6 0V7h6z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
      {showMemberDeactivate && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onDeactivate(e);
          }}
          title={deactivateLabel}
          aria-label={deactivateLabel}
          className="inline-flex items-center justify-center h-8 w-8 rounded-md text-amber-700 hover:text-amber-900 hover:bg-amber-50 transition"
        >
          <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
            <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A8.957 8.957 0 0010 18c2.31 0 4.417-.875 6.003-2.312a1.23 1.23 0 00.41-1.412A19.92 19.92 0 003.105 12a19.9 19.9 0 00-1.64 2.493zM15.75 7H11.5a.75.75 0 000 1.5h4.25a.75.75 0 000-1.5z" />
          </svg>
        </button>
      )}
      {showLegacyDelete && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(e);
          }}
          title={deleteLabel}
          aria-label={deleteLabel}
          className="inline-flex items-center justify-center h-8 w-8 rounded-md text-red-600 hover:text-red-800 hover:bg-red-50 transition"
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path
              fillRule="evenodd"
              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
      {typeof onHardDelete === 'function' && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onHardDelete(e);
          }}
          title={hardDeleteLabel}
          aria-label={hardDeleteLabel}
          className="inline-flex items-center justify-center h-8 w-8 rounded-md text-red-800 hover:text-red-950 hover:bg-red-50 transition"
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path
              fillRule="evenodd"
              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default TableRowActions;
